import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { FaBug, FaCheckCircle, FaHourglassHalf, FaTrash } from 'react-icons/fa';
import './Bugs.css';

function daysLeft(archivedUntil) {
  const ms = new Date(archivedUntil) - new Date();
  return Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)));
}

export default function CompletedBugs() {
  const { token } = useContext(AuthContext);
  const [bugs, setBugs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/support/archived-bugs', {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      credentials: 'include',
    })
      .then(res => res.json())
      .then(data => {
        setBugs(Array.isArray(data) ? data : []);
        setLoading(false);
      });
  }, [token]);

  const handleDelete = async (id) => {
    if (!window.confirm('Permanently delete this bug?')) return;
    await fetch(`/api/support/bugs/${id}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
      credentials: 'include',
    });
    setBugs(bugs => bugs.filter(b => b._id !== id));
  };

  const handleUnarchive = async (id) => {
    await fetch(`/api/support/bugs/${id}/unarchive`, {
      method: 'PATCH',
      headers: { Authorization: `Bearer ${token}` },
      credentials: 'include',
    });
    setBugs(bugs => bugs.filter(b => b._id !== id));
  };

  return (
    <div className="bugs-admin-page">
      <h1><FaCheckCircle style={{ color: '#81c784', marginRight: 8 }} /> Completed Bugs</h1>
      <div className="bugs-table-wrapper">
        <table className="bugs-table">
          <thead>
            <tr>
              <th>Ticket</th>
              <th>Title</th>
              <th>Module</th>
              <th>Priority</th>
              <th>Status</th>
              <th>Archived</th>
              <th>Days Left</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="8">Loading...</td></tr>
            ) : bugs.length === 0 ? (
              <tr><td colSpan="8">No completed bugs.</td></tr>
            ) : (
              bugs.map(bug => (
                <tr key={bug._id}>
                  <td>{bug.ticketId}</td>
                  <td>{bug.title}</td>
                  <td>{bug.module}</td>
                  <td>{bug.priority}</td>
                  <td>{bug.status}</td>
                  <td>{new Date(bug.archivedAt).toLocaleString()}</td>
                  <td>{daysLeft(bug.archivedUntil)}</td>
                  <td>
                    <button className="bug-delete-btn" onClick={() => handleDelete(bug._id)}>
                      <FaTrash /> Delete
                    </button>
                    <button className="bug-archive-btn" onClick={() => handleUnarchive(bug._id)}>
                      Unarchive
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
} 